import { forwardRef } from 'react';
import styled from 'styled-components';

import { CATEGORIES } from '@hivebrite/design-system/FontAwesomeIcon';
import { Tooltip } from '@hivebrite/design-system/Tooltip';
import type { POSITIONS } from '@hivebrite/design-system/Tooltip';

import ToolbarButton from 'hb-builder/components/common/Wrapper/components/ToolbarButton';

const preventDefault = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

interface ToolbarDragProps {
  tooltipPlace: keyof typeof POSITIONS;
  isDragging: boolean;
}

const ToolbarDrag = forwardRef<HTMLDivElement, ToolbarDragProps>(
  ({ tooltipPlace, isDragging }, ref) => {
    const label = __('Drag');

    return (
      <Tooltip
        initialPosition={tooltipPlace}
        childrenElement={isDragging ? null : label}
      >
        <Wrapper onClick={preventDefault}>
          <ToolbarButton
            iconType={CATEGORIES.SOLID}
            iconName="grip-dots-vertical"
            onClick={preventDefault}
            ariaLabel={label}
            ref={ref}
          />
        </Wrapper>
      </Tooltip>
    );
  },
);

export default ToolbarDrag;

const Wrapper = styled.div`
  cursor: move;
`;
